// buttonEvent.js
var ButtonEvent = pc.createScript('buttonEvent');
ButtonEvent.attributes.add('hoverAble', {type: 'boolean', title:'hoverAble?:'});
ButtonEvent.attributes.add('link', {type: 'boolean', title:'link?'});
ButtonEvent.attributes.add('linkAdress', {type: 'string', title:'URL'});


// initialize code called once per entity
ButtonEvent.prototype.initialize = function() {
    this.touch = this.app.touch;
    this.entity.button.on('hoverstart', this.hoverS, this);
    this.entity.button.on('hoverend', this.hoverE, this);
    this.entity.element.on('mousedown', this.onPress, this);
    this.entity.element.on('touchstart', this.onTouch, this);
};

ButtonEvent.prototype.onTouch = function() {
    if(!this.link){
        this.app.fire('buttonPressed', this.entity.name);
        } else {
            window.open(window.location.href = this.linkAdress, window.location.target = '_blank');   
        }
};

ButtonEvent.prototype.onPress = function() {
    if(!this.link){
        this.app.fire('buttonPressed', this.entity.name);
    } else {
        window.open(window.location.href = this.linkAdress, window.location.target = '_blank');
    }
};

ButtonEvent.prototype.hoverS = function(){
    if(!this.hoverAble){
        return;
    }
    this.entity.children[0].enabled = true;
};

ButtonEvent.prototype.hoverE = function(){
    if(!this.hoverAble){
        return;
    }
    this.entity.children[0].enabled = false;
};

// update code called every frame
ButtonEvent.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// ButtonEvent.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

